
import {
  defineComponent,
  onMounted,
  onUnmounted,
  onUpdated,
  ref,
  onBeforeUpdate,
} from 'vue';
import { mapState, useStore } from 'vuex';
import { ScreenOrientation } from '@ionic-native/screen-orientation';
import { FirebaseX } from '@ionic-native/firebase-x';
import JnDoc from '../../components/DocCard.vue';
import { document, search } from 'ionicons/icons';
import { addIcons } from 'ionicons';
import { Document } from '@/models/document.model';
import { SearchData } from '@/models/search.model';
import { EsService } from '@/services/es.service';
import { Categories } from '@/models/enums.model';
import * as eventBus from '../../services/event.bus.js';
import JnNewsSearchParams from '../search/NewsSearchParams.vue';
import { useRouter, useRoute } from 'vue-router';
import { SearchTypes } from '@/models/enums.model';

addIcons({
  document: document,
  search: search,
});

import {
  IonContent,
  IonButtons,
  IonMenuButton,
  IonMenuToggle,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonGrid,
  IonRow,
  IonCol,
  IonText,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonItem,
  IonList,
  IonLoading,
  IonFab,
  IonFabButton,
  IonIcon,
  modalController,
  IonSegment,
  IonSegmentButton,
  IonLabel,
  IonButton,
  alertController,
} from '@ionic/vue';

export default defineComponent({
  //inheritAttrs: false,
  name: 'JnNews',
  components: {
    IonContent,
    IonHeader,
    IonPage,
    IonToolbar,
    // IonButtons,
    //IonMenuToggle,
    // IonTitle,
    // IonMenuButton,
    //  IonGrid,
    //IonRow,
    // IonCol,
    //  IonText,
    JnDoc,
    IonInfiniteScroll,
    IonInfiniteScrollContent,
    // IonItem,
    IonSegment,
    IonSegmentButton,
    IonList,
    IonLoading,
    IonFab,
    IonFabButton,
    IonIcon,
    IonButtons,
    IonButton,
    IonMenuButton,
    IonTitle,
    IonLabel,
  },

  setup(props) {
    const store = useStore();
    const router = useRouter();
    const isDisabled = ref(false);
    const docs = ref([] as Document[]);
    const docsSize = ref();
    const scrollComponent = ref(null);

    const loading = ref(true);
    const timeout = ref(5000);

    const searchData = new SearchData({
      index: process.env.VUE_APP_JURANEWS_INDEXES,
      from: 0,
      size: 10,
      idCategory: [Categories.ULTIME_NEWS],
      featured: 1,
      withText: true,
      searchInMassime: false
    });

    function goToHome() {
      // eventBus.default.$emit('reset-home-results');
      router.push('/main');
    }

    const showAlert = async (message: string) => {
      const alert = await alertController.create({
        header: 'Errore',
        message: message,
        buttons: [
          {
            text: 'Riprova',
            role: 'retry',
          },
        ],
      });
      await alert.present();
      const { role } = await alert.onDidDismiss();
      try {
        docs.value = await EsService.getDocs(searchData);
        docsSize.value = await EsService.getDocs(searchData);
      } catch (err) {
        await showAlert(err.message);
      }
    };

    const pushDocuments = async () => {
      searchData.from = docs.value.length;
      const allDocs = await EsService.getDocs(searchData);
      for (let i = 0; i < allDocs.length; i++) {
        docs.value.push(allDocs[i]);
      }
    };

    onMounted(async () => {
      loading.value = true;
      try {
        docs.value = await EsService.getDocs(searchData);
        docsSize.value = await EsService.getDocs(searchData);
      } catch (err) {
        loading.value = false;
        await showAlert(err.message);
      }
      loading.value = false;
      eventBus.default.$on('reset-results', function(data: string) {
        docs.value = [];
        pushDocuments();
      });
    });

    const loadDocuments = async (ev: CustomEvent) => {
      setTimeout(() => {
        pushDocuments();
        const target = ev.target as HTMLIonInfiniteScrollElement;
        target.complete();

        // App logic to determine if all data is loaded
        // and disable the infinite scroll
        if (docs.value.length == docsSize.value) {
          target.disabled = true;
        }
      }, 500);
    };

    const openSearchParams = async () => {
      const modal = await modalController.create({
        component: JnNewsSearchParams,
        cssClass: 'searchModal',
      });

      modal.present();
      const result = await modal.onDidDismiss();
      if (result.data) {
        const searchData = result.data.value as SearchData;
        searchData.searchType = SearchTypes.ALL;
        searchData.searchDescription = 'Globale';
        store.commit('searchData', searchData);
        eventBus.default.$emit('news-search-data', searchData);
        router.push('/main/search');
      }
    };

    const changeType = async (ev: CustomEvent) => {
      loading.value = true;
      docs.value = [];
      searchData.from = 0;
      if (ev.detail.value == '1') {
        searchData.idCategory = [Categories.ULTIME_NEWS];
      } else if (ev.detail.value == '2') {
        searchData.idCategory = [Categories.APPROFONDIMENTI];
      }
      try {
        docs.value = await EsService.getDocs(searchData);
        docsSize.value = await EsService.getDocs(searchData);
      } catch (err) {
        loading.value = false;
        await showAlert(err.message);
      }
      loading.value = false;
    };

    pushDocuments();

    return {
      isDisabled,
      docs,
      scrollComponent,
      loadDocuments,
      timeout,
      loading,
      openSearchParams,
      changeType,
      goToHome,
    };
  },
});
